import BarLoaderAnimation from './BarLoaderAnimation';

interface ContentAreaLoadingOverlayProps {
  isLoading: boolean;
  backgroundOpacity?: number;
}

export function ContentAreaLoadingOverlay({
  isLoading,
  backgroundOpacity = 70,
}: ContentAreaLoadingOverlayProps) {
  if (!isLoading) {
    return null;
  }

  return (
    <div
      className="absolute inset-0 z-50 flex items-center justify-center rounded-lg"
      style={{
        backgroundColor: `rgba(255, 255, 255, ${backgroundOpacity / 100})`,
      }}
    >
      <BarLoaderAnimation loading={true} />
    </div>
  );
}
